import { SeasonFights } from '../../domain/models/seasonFights.model';
import { AppState } from '../app.state';

export const getSeasonFightsLoading = (state: AppState): boolean =>
  state.seasonFights.isLoading;

export const getSeasonId = (state: AppState): string | null =>
  state.seasonFights.selectedSeasonId;

export const getLastUpdated = (state: AppState): number | null =>
  state.seasonFights.lastUpdated;

export const getSeasonFights = (state: AppState): SeasonFights[] =>
  state.seasonFights.seasonFights;

export const getSeasonFightsError = (state: AppState): string | null =>
  state.seasonFights.error;
